import { z } from 'zod';
/** Path param for unattested attempt detail routes. */
export const UnattestedAttemptIdParamSchema = z.object({
    attemptId: z.string().min(1).max(128),
});
//# sourceMappingURL=ops-health.schemas.js.map